module.exports = __webpack_public_path__ + "static/media/Path 13453.dbbdf83e.svg";